import React from 'react'
import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'
import { useScrollOver, useScrollSelector } from '@gluedigital/scrollastic'
import './Cases.sass'

const Cases = () => {
  const activeClass = useScrollSelector('.case', { boundary: '60vh' })
  const progress = useScrollOver('#cases')

  return (
    <section className="section" id="cases">
      <div className="container">
        <div className="case-intro">
          <div className="text">
            <h1>
              <FormattedMessage id="home.cases.title" />
            </h1>
            <p>
              <FormattedMessage id="home.cases.text" />
            </p>
          </div>
        </div>
        <div id="case-1" className="case split">
          <div className="item left">
            <div className={`case-image ${activeClass || ''}`} id="case-1-image" />
          </div>
          <div className="item right">
            <div className="text">
              <h2>
                <FormattedMessage id="home.cases.case-1.title" />
              </h2>
              <p>
                <FormattedMessage id="home.cases.case-1.text" />
              </p>
            </div>
          </div>
        </div>
        <div id="case-2" className="case split">
          <div className="item left">
            <div className={`case-image ${activeClass || ''}`} id="case-2-image" />
          </div>
          <div className="item right">
            <div className="text">
              <h2>
                <FormattedMessage id="home.cases.case-2.title" />
              </h2>
              <p>
                <FormattedMessage id="home.cases.case-2.text" />
              </p>
            </div>
          </div>
        </div>
        <div id="case-3" className="case split">
          <div className="item left">
            <div className={`case-image ${activeClass || ''}`} id="case-3-image" />
          </div>
          <div className="item right">
            <div className="text">
              <h2>
                <FormattedMessage id="home.cases.case-3.title" />
              </h2>
              <p>
                <FormattedMessage id="home.cases.case-3.text" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="case-mix" className="mix case">
        <div className="text">
          <h2>
            <MarkdownMessage id="home.cases.mix.title" />
          </h2>
          <p>
            <FormattedMessage id="home.cases.mix.text" />
          </p>
        </div>
        <div className="mix-bg">
          <div className={`mix-image ${activeClass || ''}`} />
        </div>
      </div>
      <div id="stroke-cases-1" className="stroke"
        style={{ transform: `translateY(${progress * 160}vh` }} />
      <div id="stroke-cases-2" className="stroke"
        style={{ transform: `translateY(${progress * -140}vh` }} />
      <div id="stroke-cases-3" className="stroke"
        style={{ transform: `translateY(${progress * 195}vh` }} />
      <div id="stroke-cases-4" className="stroke"
        style={{ transform: `translateY(${progress * -135}vh` }} />
      <div id="stroke-cases-5" className="stroke"
        style={{ transform: `translateY(${progress * -170}vh` }} />
      <div id="stroke-cases-6" className="stroke"
        style={{ transform: `translateY(${progress * 155}vh` }} />
    </section>
  )
}

export default Cases
